import type { LocalDate } from "@js-joda/core";
import { Api } from "services/api/api.service";
import type { UpdateStaffWorkerSalaryRequest } from "services/api/company/staff.service";
import {
  toIsoDateStartOfDayUtc,
  toNonNegativeNumber,
} from "./domains/employment/profilePanel.payload.logic";
import type { EmploymentDetailsForm } from "./profilePanel.contract";

interface AddSalaryParams {
  companyId: number | null;
  workerId: number | null;
  employmentId: number | null;
  effectiveFromDate: LocalDate | null;
  editedEmploymentDetails: EmploymentDetailsForm;
  translate: (key: string, options?: Record<string, unknown>) => string;
  setSaveError: (value: string) => void;
  executeSavingAction: (action: () => Promise<void>) => void;
  reloadProfile: () => void;
}

interface DeleteSalaryParams {
  companyId: number | null;
  workerId: number | null;
  employmentId: number | null;
  salaryId: number;
  translate: (key: string, options?: Record<string, unknown>) => string;
  setSaveError: (value: string) => void;
  executeSavingAction: (action: () => Promise<void>) => void;
  reloadProfile: () => void;
}

export const addSalary = (params: AddSalaryParams): void => {
  if (params.companyId == null || params.workerId == null) return;
  const companyId = params.companyId;
  const workerId = params.workerId;
  if (params.effectiveFromDate == null) {
    params.setSaveError(params.translate("Alerts.SomethingWentWrong"));
    return;
  }
  if (params.employmentId == null) {
    params.setSaveError(params.translate("Alerts.SomethingWentWrong"));
    return;
  }
  const employmentId = params.employmentId;

  const payload: UpdateStaffWorkerSalaryRequest = {
    salaryId: 0,
    startDate: toIsoDateStartOfDayUtc(params.effectiveFromDate),
    value: toNonNegativeNumber(params.editedEmploymentDetails.salary),
  };

  params.executeSavingAction(async () => {
    await Api().company.staff.addWorkerSalary(
      companyId,
      workerId,
      payload,
      employmentId,
    );
    params.reloadProfile();
  });
};

export const deleteSalary = (params: DeleteSalaryParams): void => {
  if (params.companyId == null || params.workerId == null) return;
  const companyId = params.companyId;
  const workerId = params.workerId;
  if (params.employmentId == null) {
    params.setSaveError(params.translate("Alerts.SomethingWentWrong"));
    return;
  }
  const employmentId = params.employmentId;

  params.executeSavingAction(async () => {
    await Api().company.staff.deleteWorkerSalary(
      companyId,
      workerId,
      employmentId,
      params.salaryId,
    );
    params.reloadProfile();
  });
};
